// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-55d64418]{height:50px;width:151px;display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
